import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { store } from './store';
import App from './containers/app';
import AppRouter from './components/AppRouter';
import 'core-js/es/array/includes';
import './index.css';
import './semantic/dist/semantic.css';
import 'react-tippy/dist/tippy.css';
import {
  useRaygun,
  useGoogleAnalytics,
  useGoogleTagManager,
  useZendesk,
  useBeamer,
} from './hooks';
import './css';
import { useClarity } from './hooks/clarity/useClarity';
import { ThemeManager } from './utils/themeManager';
import { installTrackingHeaders } from './helpers/trackingHeaders';

// TODO - add this  to app once converted from class to functional component
const AppWrapper = () => {
  useRaygun();
  useGoogleAnalytics();
  useGoogleTagManager();
  useClarity();

  useZendesk();
  useBeamer();

  // Initialize theme on app startup
  useEffect(() => {
    ThemeManager.initializeTheme();
  }, []);

  useEffect(() => {
    if (window.zE) {
      window.zE("webWidget:on", "open", () => {
        if (window.Beamer) {
          const selector = document.getElementById("beamerSelector") as HTMLElement;
          selector.style.visibility = "hidden";
        }
      });

      window.zE("webWidget:on", "close", () => {
        if (window.Beamer) {
          const selector = document.getElementById("beamerSelector") as HTMLElement;
          selector.style.visibility = "visible";
        }
      });
    }
  }, [window.zE, window.Beamer]);

  return (
    <div>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </div>
  );
};

installTrackingHeaders();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <AppRouter>
      <AppWrapper />
    </AppRouter>
  </Provider>
);
